// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FH-z","twoColumnImage":"GH-z"};